<template>
  <div class="relative inline-block text-left">
    <vue-tailwind-datepicker
      :formatter="formatter"
      :disable-date="disabled"
      as-single
      v-model="dateValue"
    >
      <div class="flex">
        <button
          class="inline-flex w-full justify-center rounded-sm border border-gray-300 bg-white text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-100 hover:text-gray-700 p-2 pl-2.5 focus:ring-0 focus:outline-0 focus:ring-offset-0 disabled:opacity-50"
          :disabled="props.disabled"
        >
          <calendar class="-ml-1 mr-2 h-4 w-4 text-gray-500" />
          {{ t("validation.attributes.schedule_for") }}
          <chevron-down class="-mr-1 ml-2 h-4 w-4" aria-hidden="true" />
        </button>
      </div>
    </vue-tailwind-datepicker>
  </div>
</template>

<script setup>
import ChevronDown from "@/Tailwind/Icon/ChevronDown";
import VueTailwindDatepicker from "vue-tailwind-datepicker";
import { defineEmits, defineProps, ref, watchEffect } from "vue";
import Calendar from "@/Tailwind/Icon/Calendar";

import { useI18n } from "vue-i18n";
const { t } = useI18n();

const props = defineProps({
  label: String,
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(["click"]);

const dateValue = ref();
const formatter = ref({
  date: "DD MMM YYYY",
  month: "MMM",
});
const today = new Date();
const disabled = (date) => {
  const isToday = today.toDateString() === date.toDateString();
  return date < new Date() && !isToday;
};

watchEffect(() => {
  if (dateValue.value !== undefined) {
    const today = new Date(dateValue.value);
    today.setHours(23, 59, 59, 0);
    emit("click", today);
  }
});
</script>
